module.exports = __webpack_public_path__ + "img/titleAtive2.e714263.webp";